import {
  getContracts,
  getOneContracts,
  createContracts,
  deleteContracts,
  updateContracts,
  updateContractsPatch,
  createContractInvoice,
  updateContractInvoice,
  updatePatchContractInvoice,
  deleteContractGoods,
  deleteContractInstruments,
  deleteRequirementGoods,
  deleteRequirementInstruments
} from '@/api/agrements'

export default {
  FETCH_CONTRACTS_LIST({ commit }, params) {
    return getContracts(params)
      .then(res => {
        commit('SET_CONTRACTS_LIST', res.data)
      })
      .catch((err) => {
        return err
      })
  },
  CREATE_CONTRACTS_LIST(_, data) {
    return createContracts(data)
  },
  UPDATE_CONTRACTS_LIST(_, data) {
    return updateContracts(data)
  },
  UPDATE_PATCH_CONTRACTS_LIST(_, data) {
    return updateContractsPatch(data)
  },
  DELETE_CONTRACTS_LIST(_, data) {
    return deleteContracts(data)
  },
  FETCH_ONE_CONTRACTS({ commit }, id) {
    return getOneContracts(id)
      .then(res => {
        commit('SET_ONE_CONTRACTS', res.data)
      })
  },
  CREATE_CONTRACT_INVOICE({ commit }, payload) {
    return createContractInvoice(payload)
  },
  UPDATE_CONTRACT_INVOICE({ commit }, payload) {
    return updateContractInvoice(payload)
  },
  UPDATE_PATCH_CONTRACT_INVOICE({ commit }, payload) {
    return updatePatchContractInvoice(payload)
  },
  DELETE_CONTRACT_GOODS(_, data) {
    return deleteContractGoods(data)
  },
  DELETE_CONTRACT_INSTRUMENTS(_, data) {
    return deleteContractInstruments(data)
  },
  DELETE_REQUIREMENT_GOODS(_, data) {
    return deleteRequirementGoods(data)
  },
  DELETE_REQUIREMENT_INSTRUMENTS(_, data) {
    return deleteRequirementInstruments(data)
  },
}
